export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const THREE_MINUTES = MINUTE * 3;
export const TWENTY_FOUR_HOURS = MINUTE * 60 * 24;
export const ONE_HOUR = MINUTE * 60;
